import { useContext } from 'react';

import { Context } from 'src/contexts/slug-context';

export function useSlug() {
  return useContext(Context);
}

export default useSlug;
